import React, { useLayoutEffect,useEffect, useState } from "react";
import  bg_coupon from "img/bg_coupon.png"
import  ticket_discount from "img/ticket_discount.png"
import Button from '@mui/material/Button';
import CustomBtn from "components/fragments/CustomBtn";



export default function CouponCard({item,handleOnClick,selected,...props}) {

  


  
  return (
    <div className="relative cardCoupon" >
      <img src={bg_coupon} className="w-100 rounded-xl" />
      <div className="absolute flex top-0 left-0 w-[100%] h-[100%] p-[7px]">
          <img src={item.image} className=" object-cover aspect-[129/103] ml-[1px]" />
         <div className="pl-[18px] pr-[8px] flex  flex-col flex-fill">
              <div className="flex items-center text-[12px]">
                <img src={ticket_discount} className="mt-[1px] mr-2" /> <span>{item.name}</span>
              </div>
              <div className="text-[18px] font-bold">{item.value} {item.discountTypeId == 1 ? "%" : "฿"}</div>
              <div className="text-[14px] ">{item.detail}</div>
              <div className="flex items-center mt-auto w-100 ">
                <div className="text-[12px] text-[#061126]/[0.5] mr-auto">{item.expire}</div>
                <CustomBtn
                  onClick={() => handleOnClick()}
                  className={`leading-[0.8] w-fit min-w-[min(7.96vw,72px)] text-14  font-[500] min-h-[min(3.32vw,34px)] rounded-[min(0.39vw,4px)] ${selected ? "bg-[#6D788D]" :  "btn-main-active" }  text-white   `}
                  btntxt={"ใช้"}
                />
              </div>
         </div>
      </div>
    </div>
  );
}
